import Vue from 'vue'
import Router from 'vue-router'
import { isAuthenticated } from '@/utils/auth'

Vue.use(Router)

// 路由懒加载
const Login = () => import('@/views/auth/Login')
const Register = () => import('@/views/auth/Register')
const ForgotPassword = () => import('@/views/auth/ForgotPassword')
const Layout = () => import('@/components/layout/Layout')
const Home = () => import('@/views/home/Index')
const SimpleHome = () => import('@/views/home/SimpleHome')
const Music = () => import('@/views/music/Index')
const Profile = () => import('@/views/profile/Index')

const router = new Router({
  mode: 'hash',
  base: '/lzyp/', // 添加base前缀
  routes: [
    {
      path: '/',
      redirect: '/home'
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: { requiresAuth: false }
    },
    {
      path: '/register',
      name: 'Register',
      component: Register,
      meta: { requiresAuth: false }
    },
    {
      path: '/forgot-password',
      name: 'ForgotPassword',
      component: ForgotPassword,
      meta: { requiresAuth: false }
    },
    // 添加一个用于刷新的路由
    {
      path: '/refresh',
      name: 'Refresh',
      component: {
        render: h => h('div'),
        beforeRouteEnter(to, from, next) {
          const { redirect } = to.query
          if (redirect) {
            next(redirect)
          } else {
            next('/home')
          }
        }
      }
    },
    // 统一使用Layout作为外层组件
    {
      path: '/',
      component: Layout,
      children: [
        // 首页需要认证
        {
          path: 'home',
          name: 'Home',
          component: Home,
          meta: { requiresAuth: true }
        },
        // 简化版首页路由
        {
          path: 'simple-home',
          name: 'SimpleHome',
          component: SimpleHome,
          meta: { requiresAuth: true }
        },
        // 其他页面需要认证
        {
          path: 'music',
          name: 'Music',
          component: Music,
          meta: { requiresAuth: true }
        },
        {
          path: 'profile',
          name: 'Profile',
          component: Profile,
          meta: { requiresAuth: true }
        }
      ]
    }
  ]
})

// 输出路由表，帮助调试
console.log('路由表:', router.options.routes)

// 全局前置守卫
router.beforeEach((to, from, next) => {
  console.log(`路由跳转开始: ${from.path} -> ${to.path}`)
  console.log('路由匹配项:', to.matched)
  
  // 刷新路由特殊处理
  if (to.path === '/refresh') {
    console.log('检测到刷新路由，准备重定向到:', to.query.redirect)
    return next()
  }
  
  // 判断该路由是否需要登录权限
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // 需要登录权限
    if (!isAuthenticated()) {
      console.log(`访问${to.path}需要权限，但用户未登录，重定向到登录页面`)
      // 未登录，跳转到登录页面
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    } else {
      console.log(`用户已登录，允许访问${to.path}`)
      next()
    }
  } else {
    console.log(`访问${to.path}不需要权限，直接通过`)
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js